import type { ListBuilderList } from '../../../types';
import {
	accountColumn,
	actionColumn,
	fileVsRegulatorColumn,
	licenseColumn,
	salesColumn,
	whyHereColumn,
} from '../columns';
import { hideOtherCardFilters } from '../filter-rules';

/**
 * Replacement Available (PD-16256) — a dead or mis-numbered license for which the
 * matchmaker found an in-force registration of the same kind, from the same
 * board, at the customer's own address. Review Replacement opens it in the
 * matchmaker confirmation screen.
 */
export const replacementAvailableList: ListBuilderList = {
	id: 'compliance-replacement-available',
	cacheTTL: 300000,
	// Tab label, deliberately short (Chris, 2026-09-20) so more tabs show in
	// the Needs Attention strip; the rest sit under More, which is accepted
	// (Chris, 2026-09-27). The full name is above and on the dashboard card.
	name: 'Replacement',
	type: 'default',
	active: true,
	sortOrder: 12,
	filterRules: {
		...hideOtherCardFilters(['licenseHasReplacement']),
		licenseActiveBuyer: {
			defaultValue: [{ id: 'yes', label: 'Buying (sale in 90 days)' }],
			locked: true,
		},
		licenseHasReplacement: {
			defaultValue: [
				{ id: 'yes', label: 'Matchmaker found an in-force replacement' },
			],
			locked: true,
		},
	},
	columns: [
		accountColumn,
		salesColumn,
		licenseColumn,
		fileVsRegulatorColumn,
		whyHereColumn,
		actionColumn,
	],
	defaultSortId: 'sales-90-desc',
};
